var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('BasePageHeader',{attrs:{"large-title":true},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("報到核銷")]},proxy:true}])}),_c('QrcodeScanner')],1)}
var staticRenderFns = []

export { render, staticRenderFns }